module.exports = __webpack_public_path__ + "assets/1bb6698b5ab2d63ced307a491a791885.png";